/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Section_Friend_GuestInputs */

const fr_membership_section_friend_guest = /** @type {(inputs: Membership_Section_Friend_GuestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invité · 1 ami`)
};

/**

* @param {Membership_Section_Friend_GuestInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_section_friend_guest = /** @type {((inputs?: Membership_Section_Friend_GuestInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Section_Friend_GuestInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_section_friend_guest(inputs)
});